import axios from "axios";
import { supabase } from "./supabase";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const client = axios.create({ baseURL: API });

client.interceptors.request.use(async (config) => {
  try {
    const { data } = await Promise.race([
      supabase.auth.getSession(),
      new Promise((res) => setTimeout(() => res({ data: null }), 2500)),
    ]);
    const token = data?.session?.access_token;
    if (token) config.headers.Authorization = `Bearer ${token}`;
  } catch {
    // never let an auth hiccup block API requests
  }
  return config;
});

export const fetcher = (url) => client.get(url).then((r) => r.data);
